import { useContext } from 'react';
import { ScheduleFormWidgetContext } from './ScheduleFormWidgetContext';

export default function useScheduleFormWidgetContext() {
    const contextValue = useContext(ScheduleFormWidgetContext);
    if (!contextValue) {
        throw new Error('useScheduleFormWidgetContext must be used within a ScheduleFormWidgetContext');
    }
    return contextValue;
}
